export default {
  isFirstLogin: state => state.isFirstLogin,
  isEmailVerified: (state, getters) => !getters.isLoggedIn || state.isEmailVerified,
  isComingSoonSignUp: state => state.isComingSoonSignUp,
  token: state => state.token,
  isLoggedIn: state => Boolean(state.token),
  logoutResolver: state => state.logoutResolver,
  tokenRefreshRequired: state => state.tokenRefreshRequired,
  tokenExpired: state => state.tokenExpired,
  temporaryToken: state => state.temporaryToken,
  logoutLoading: state => state.logoutLoading,
  mfa: state => state.mfa,
  mfaLoading: state => state.mfaLoading,
};
